<template>
    <bar-chart
        id="profitLoss"
        :data="barDataFormatter"
        xkey="y"
        :resize="true"
        ykeys='["a", "b"]'
        :labels='labels'
        barColors='["#22B24F", "#dc3545"]'
        hideHover="auto"
        grid="true"
        gridTextFamily="Muli"
        gridTextColor="#65708B"
        :yLabelFormat="money"
        >
    </bar-chart>
</template>

<script>
import { BarChart } from 'vue-morris'

export default {
    components: {
        BarChart
    },
    props: ['barData', 'currency'],
    data() {
        return {
            barDataFormatter: [{
                y: this.__('HomeResult'),
                a: this.barData.total_profit,
                b: this.barData.total_loss,
            }],
            labels: [
                this.__('HomeWinnings'),
                this.__('HomeLosses'),
            ]
        }
    },
    methods: {
        money(value) {
            return this.currency + ' ' + value;
        }
    }
}
</script>

<style>

</style>
